var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"100%","height":"300px","frameborder":"0","src":_vm.mapsrc,"allowfullscreen":""}})}
var staticRenderFns = []

export { render, staticRenderFns }